<script>

export default {
  name: 'KerryThTip'
}
</script>

<template lang="pug" src="./KerryThTip.pug"></template>
<style lang="scss" src="./KerryThTip.scss" scoped></style>
